import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

declare global {
  interface Window {
    Constants?: { URL_BASE_SERVICES: string };
  }
}

function resolveAutofirmaServletBase(apiUrl: string): string {
  if (apiUrl.startsWith('http://') || apiUrl.startsWith('https://')) {
    return apiUrl;
  }
  return `${window.location.origin}${apiUrl}`;
}

window.Constants = {
  ...(window.Constants ?? {}),
  URL_BASE_SERVICES: resolveAutofirmaServletBase(environment.API_URL),
};

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
